import '../css/styles.scss';

window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
import EventHandler from 'bootstrap/js/src/dom/event-handler';
import Swiper from 'swiper/bundle';
import TomSelect from 'tom-select';
import {merge, debounce, throttle} from 'lodash';
import intlTelInput from 'intl-tel-input';
import Inputmask from 'inputmask';
import noUiSlider from 'nouislider';
import wNumb from 'wnumb'; // Number & Money formatting

import * as projectConstants from '%helpers%/constants';
import * as projectUtils from '%helpers%/utils';
import * as projectHelpers from '%helpers%/helpers';
import MultipleSelectFilter from '%modules%/filter-multiselect';

window.springEQ = window.springEQ || {};
window.springEQ.constants = window.springEQ.constants || projectConstants;
window.springEQ.helpers = {...window.springEQ.helpers, ...projectUtils, ...projectHelpers};
window.springEQ.helpers.initiateFilterMultiSelect = (el, config = {}) => new MultipleSelectFilter(el, config);

if (!window.matchMedia('(pointer:fine)').matches) document.body.classList.add('no-cursor');

import {initWidgets} from '%widgets%/widgets';
import {initiatePageLayout} from '%modules%/page-layout';
import {initBootstrapAdditions} from '%modules%/bootstrap';
import {initBlog} from '%modules%/blog';
import {copyTextToClipboard, initFormElements} from '%helpers%/helpers';
import Video from '%modules%/video';
import {initializeHandleUmbracoFormsAjax} from '%modules%/handle-umbraco-forms-ajax';

initBootstrapAdditions();
initFormElements();
initiatePageLayout();
initWidgets();
initBlog();
initializeHandleUmbracoFormsAjax();

document.querySelectorAll('[data-toggle="scrollTop"]').forEach(el => {
  el.addEventListener('click', event => {
    event.preventDefault();
    window.springEQ.helpers.scrollToTop();
  });
});

EventHandler.on(
  document,
  'click.bs.modal.data-api',
  '[data-bs-toggle="modal-video"], .video-button',
  ({delegateTarget}) => {
    if (delegateTarget.closest('.swiper') && delegateTarget.closest('.swiper').swiper._moved) return;
    new Video(delegateTarget);
  }
);

EventHandler.on(document, 'click.bs.copyText.data-api', '[data-bs-toggle="copyText"]', ({delegateTarget}) => {
  const {value, successText} = delegateTarget.dataset;

  document.querySelectorAll('[data-bs-toggle="copyText"]').forEach(el => {
    if (el !== delegateTarget) {
      const bsTooltip = bootstrap.Tooltip.getInstance(el);
      if (bsTooltip) bsTooltip.hide();
    }
  });

  if (value == 'url') copyTextToClipboard(delegateTarget, window.location.href, successText);
  else if (value) copyTextToClipboard(delegateTarget, value, successText);
});

document.querySelectorAll('.copy-link').forEach(button => {
  const {value, successText} = button.dataset;
  button.addEventListener('click', async e => {
    e.preventDefault();

    try {
      const text = value == 'url' ? window.location.href : value;
      navigator.clipboard.writeText(text).then(function () {
        const msgEl = document.getElementById('copyToast');
        if (msgEl) {
          msgEl.querySelector('#copyToast .toast-body').innerHTML = successText;
          var toast = new bootstrap.Toast(msgEl);
          toast.show();
        }
      });
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const toastEl = document.getElementById('cookieToast');
  const btnAcceptToast = document.getElementById('acceptCookies');
  const btnDeclineToast = document.getElementById('declineCookies');

  if (!toastEl) return;

  const storageKey = 'cookieToastHidden';
  const durationDays = parseInt(toastEl.dataset.duration || '30', 10);

  const hiddenUntil = localStorage.getItem(storageKey);

  if (hiddenUntil && Date.now() < parseInt(hiddenUntil, 10)) {
    return;
  }

  const toast = new bootstrap.Toast(toastEl, {
    autohide: false,
  });

  toast.show();

  const hideToastForDuration = () => {
    const expiresAt = Date.now() + durationDays * 24 * 60 * 60 * 1000;

    localStorage.setItem(storageKey, expiresAt.toString());

    toast.hide();
  };

  btnAcceptToast?.addEventListener('click', hideToastForDuration);
  btnDeclineToast?.addEventListener('click', hideToastForDuration);

  initSpeedbumpToast();
});

function initSpeedbumpToast() {
  const toastEl = document.getElementById('speedbumpToast');
  if (!toastEl || !window.bootstrap) return;

  let excludedDomains = [];

  try {
    excludedDomains = JSON.parse(toastEl.dataset.speedbumpExcludedDomains || '[]');
  } catch (e) {
    excludedDomains = [];
  }

  const toast = bootstrap.Toast.getOrCreateInstance(toastEl, {
    autohide: false,
  });

  let pendingUrl = null;
  let pendingTarget = null;

  document.addEventListener('click', function (e) {
    const anchor = e.target.closest('a[href]');
    if (!anchor) return;

    const href = anchor.getAttribute('href');

    // Ignore anchors/mailto/tel/javascript
    if (
      !href ||
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('javascript:')
    ) {
      return;
    }

    let resolved;

    try {
      resolved = new URL(href, window.location.href);
    } catch (_) {
      return;
    }

    // Only external http/https links
    if (resolved.protocol !== 'http:' && resolved.protocol !== 'https:') {
      return;
    }

    // Ignore same hostname
    if (resolved.hostname === window.location.hostname) {
      return;
    }

    // Ignore excluded domains
    for (let i = 0; i < excludedDomains.length; i++) {
      const domain = excludedDomains[i]?.trim();

      if (!domain) continue;

      if (resolved.hostname === domain || resolved.hostname.endsWith('.' + domain)) {
        return;
      }
    }

    e.preventDefault();

    pendingUrl = resolved.href;
    pendingTarget = anchor.target || '';

    toast.show();
  });

  const continueBtn = document.getElementById('continueSpeedbump');
  const cancelBtn = document.getElementById('cancelSpeedbump');

  if (continueBtn) {
    continueBtn.addEventListener('click', function () {
      if (!pendingUrl) return;

      toast.hide();

      if (pendingTarget === '_blank') {
        window.open(pendingUrl, '_blank', 'noopener,noreferrer');
      } else {
        window.location.href = pendingUrl;
      }
    });
  }

  if (cancelBtn) {
    cancelBtn.addEventListener('click', function () {
      pendingUrl = null;
      pendingTarget = null;

      toast.hide();
    });
  }

  toastEl.addEventListener('hidden.bs.toast', function () {
    pendingUrl = null;
    pendingTarget = null;
  });
}
